/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.


==============================================================================*/

if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + attributeToString(note),
        dataType: 'json',
        beforeSend: function() {
          $body.trigger('beforeUpdateCartNote.ajaxCart', note);
        },
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          }
          else {
            ShopifyAPI.onCartUpdate(cart);
          }
          $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        beforeSend: function(jqxhr, settings) {
          $body.trigger('beforeAddItem.ajaxCart', form);
        },
        success: function(line_item) {
          if ((typeof callback) === 'function') {
            callback(line_item, form);
          }
          else {
            ShopifyAPI.onItemAdded(line_item, form);
          }
          $body.trigger('afterAddItem.ajaxCart', [line_item, form]);


        },
        error: function(XMLHttpRequest, textStatus) {
          if ((typeof errorCallback) === 'function') {
            errorCallback(XMLHttpRequest, textStatus);
          }
          else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
          $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  // Not really sure if you've forgot to var 
  var cart = [];
  $.ajax({
    url: "/cart.js",
    cache: false,
    dataType: "json",
    success: function(cart, textStatus) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $(document.body).trigger('afterGetCart.ajaxCart', cart);

      $(".counter").text(cart.item_count);
      $(".header__cart-count").text(cart.item_count);

      // For Kirby Discount
      for(var i = 0; i< cart.items.length; i++){
        var k =i+1;
        var ids = ["1563782414454", "2270248271990", "2470888308854","1562700808310", "1563156873334", "1563355414646", "2152766177398"];
        var ids_length = ids.length;
        var variyant_id = cart.items[i].product_id;
        for(j=0; j<ids_length; j++)
        {

          if(ids[j] == variyant_id)
          {
            var cook = getCookie("pre-order_"+variyant_id);
            if(cook=="pre-order")
            {
              $('.ajaxcart__row.cartrow.innerpro[data-line="'+k+'"] .ajaxcart__product-meta').hide();
              $('.ajaxcart__row.cartrow.innerpro[data-line="'+k+'"] p.cartprice').addClass("cartstrikeprice");
              var act_price= Shopify.formatMoney(cart.items[i].line_price);
              act_price =  act_price.replace('$','');
              act_price =  act_price.replace(',','');

              var calcPerc = 10/100 * act_price;
              calcPerc = calcPerc.toFixed(2);
              var new_price= act_price - calcPerc;
              new_price = new_price.toFixed(2);
              $('.ajaxcart__row.cartrow.innerpro[data-line="'+k+'"] p.cartprice').after('<p class="new__price">'+Shopify.formatMoney(new_price)+'</p>');
              $('.ajaxcart__row.cartrow.innerpro[data-line="'+k+'"] .ajaxcart__qty-remove').after('<span class="discount__code" style="font-size:14px;color:#323232;display: block;margin-top:10px;">10% Off (-'+Shopify.formatMoney(calcPerc)+')</span>');


              $('#discount').val('PREORDER10%OFF'); 
              var tottal = $('.ajaxcart__footer .total .carto').text();
              tottal =  tottal.replace('$','');
              tottal =  tottal.replace(',','');
              var final_total= tottal - calcPerc;
              final_total = final_total.toFixed(2);
              $('.ajaxcart__footer .total .carto').text(Shopify.formatMoney(final_total));
            }
          }
        }
        /*if(string.indexOf("15Now") != -1){
         var k=i+1;
         $('.ajaxcart__row.cartrow.innerpro[data-line="'+k+'"] p.cartprice').addClass("cartstrikeprice");
         var act_price= Shopify.formatMoney(cart.items[i].line_price);
         act_price =  act_price.replace('$','');
         act_price =  act_price.replace(',','');
         var calcPerc = 15/100 * act_price;
    	 calcPerc = calcPerc.toFixed(2);
         var new_price= act_price - calcPerc;
    	 new_price = new_price.toFixed(2);
         $('.ajaxcart__row.cartrow.innerpro[data-line="'+k+'"] p.cartprice').after('<p class="new__price">'+Shopify.formatMoney(new_price)+'</p>');
         $('.ajaxcart__row.cartrow.innerpro[data-line="'+k+'"] .ajaxcart__qty-remove').after('<span class="discount__code" style="font-size:14px;color:#323232;display: block;margin-top:10px;">15% Off (-'+Shopify.formatMoney(calcPerc)+')</span>');
      	 $('#discount').val('15Now');
         var tottal = $('.ajaxcart__footer .total .carto').text();
         tottal =  tottal.replace('$','');
         tottal =  tottal.replace(',','');
         var final_total= tottal - calcPerc;
    	 final_total = final_total.toFixed(2);
         $('.ajaxcart__footer .total .carto').text(Shopify.formatMoney(final_total));
       }*/
        /*if(cart.items[i].vendor == 'Kirby'){
        $('#discount').val('15Now');
      }*/
      }
    },
    error: function (err) { console.log(err); }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        beforeSend: function() {
          $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
        },
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          }
          else {
            ShopifyAPI.onCartUpdate(cart);
          }
          $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '${{amount}}',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () { 
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
      .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        globt={},
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    globt = {tkey:"okok"};

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if( cart.item_count < 1){
        globt = {tkey:null};
      } 
      // Create item's data object and add to 'items' array
      const properties = {}
      
      for (let i in cartItem.properties) {
        if (i[0] != '_') {
          properties[i] = cartItem.properties[i]
        }
      }
      
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,

        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      tot:globt.tkey,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);

      }
    });

    async function addRemoveFromCartToGTM(id) {
      const cart_data = await $.getJSON('/cart.js');
      let deletedItem = null;
      cart_data.items.forEach(item => {
        if (item.key !== id) { return; }
        deletedItem = item;
      });

      const deletedItemid = `shopify_US_${deletedItem.id}_${deletedItem.variant_id}`;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event':undefined, 'send_to':undefined, 'ecommerce': undefined });
      gtag('event','remove_from_cart', {
        'currency': cart_data.currency,
        'ecomm_pagetype': 'cart',
        'ecomm_prodId': [ deletedItemid ],
        'ecomm_totalvalue': deletedItem.final_price,
        'send_to': 'G-0EGLNSKEQ8',
        'value': deletedItem.price / 100,
        'items': [{
          'brand': deletedItem.vendor,
          'category': deletedItem.product_type,
          'coupon': null,
          'id': deletedItemid,
          'name': deletedItem.handle,
          'price': `${deletedItem.price / 100}`,
          'quantity': `${deletedItem.quantity}`,
          'variant': deletedItem.variant_title
        }]
      });
    }

      // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove, .ajaxcart__qty-remove--cart', function() {
        if (isUpdating) {
            return;
        }

        var $el = $(this),
            line = $el.data('line'),
            qty = 0;

        addRemoveFromCartToGTM($el.data('id'));

        // Remove all items of this type from the cart
        if (line) {
            updateQuantity(line, qty);
        }

      });
    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
